import type { AccountNumber, Card, DebitCardDetailEndpoint } from '../generated-types';
import { CONTEXT_PATH } from './index';
import { get } from './request';

const SERVICE_PATH = 'rest/resource/creditcards';
const SERVICE_PATH_DEBIT = 'rest/resource/debitcards';

export const getCardLink = (accountNumber: AccountNumber): Promise<DebitCardDetailEndpoint[]> => {
    return get<DebitCardDetailEndpoint[]>(`${CONTEXT_PATH}/${SERVICE_PATH_DEBIT}/${accountNumber.value}`);
};

export const getCardsOverview = (): Promise<Card[]> => {
    return get<Card[]>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
};
